import React from 'react';
import PropTypes from 'prop-types';
import FeaturesBox from '../FeaturesBox/FeaturesBox';
import { isNull } from 'lodash';
import "./ResumeBanner.css"

const ROOT = process.env.REACT_APP_CMS_STATIC;

ResumeBanner.propTypes = {
    resumeItems:PropTypes.array
};

function ResumeBanner({resumeItems=[],...props}) {
    return (
        <div className="resume-container">
            {!isNull(resumeItems) && resumeItems.map((item, index)=>(
                <div key={index} className="resume-content">
                <FeaturesBox
                    key={index}
                    titulo={item?.titulo}
                    imagenUrl={ROOT+item?.imagen?.urls[0]}
                    featUrl={item?.urlBotonAccion?.url}
                    titlePos = "middle"
                    descripcion={item?.descripcion?.html}
                    showMoreInfoButton={true}
                    moreInfoButtonImage={ROOT+item?.imagenBotonAccion?.urls[0]}
                    moreInfoButtonImageHeight={75}
                />
                </div>
            )) 
                
            }
        </div>
    );
}

export default ResumeBanner;